import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { MustMatch } from '@app/modules/central-login/util/must-match.validator';
import { environment } from '../../../../environments/environment';
import { AuthenticationService, CreateCentralUserDTO, CommonUtil, PasswordStrengthValidator, Platform, CommonPlatformService } from 'psd-common';

@Component({
  selector: 'central-login-join',
  templateUrl: 'central-login-create-user.component.html'
})
export class CentralLoginCreateUserComponent implements OnInit {
  public createAccountForm: FormGroup;
  public submitted: boolean = false;
  public submitting: boolean = false;
  public prefix: string;
  public currentPlatform: Platform;
  public userEmail: string;
  public joinToken: string;
  public userCreated: boolean = false;
  public userCreationFailure: boolean = false;
  public checkPassword: any = {};
  public CommonUtil: typeof CommonUtil = CommonUtil;

  constructor(@Inject(DOCUMENT) private document: Document,
              private renderer: Renderer2,
              private formBuilder: FormBuilder,
              private route: ActivatedRoute,
              private platformService: CommonPlatformService,
              private authenticationService: AuthenticationService,
              private router: Router) {
  }

  get form() { return this.createAccountForm.controls; }

  ngOnInit() {
    this.renderer.addClass(this.document.body, 'login');
    this.route.queryParams.subscribe(_params => {
      this.prefix = _params.platform;
      this.userEmail = _params.email;
      this.joinToken = _params.joinToken;
      if(this.prefix) {
        this.platformService.getExternalPlatformDetails(this.prefix).subscribe(_platform => {
          this.currentPlatform = _platform;
        });
      }
    });

    this.createAccountForm = this.formBuilder.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(8), PasswordStrengthValidator()]],
      confirmPassword: ['', Validators.required]
    }, {
          validator: MustMatch('password', 'confirmPassword')
    });
  }

  createAccount() {
    this.submitted = true;
    this.submitting = true;

    if (this.createAccountForm.invalid || CommonUtil.checkInvalidPassword(this.checkPassword)) {
      this.submitting = false;
      return;
    }

    let json = JSON.parse(JSON.stringify(this.createAccountForm.value, null, 4));
    let createCentralUserDTO = new CreateCentralUserDTO();
    createCentralUserDTO.email = this.userEmail;
    createCentralUserDTO.firstName = json.firstName;
    createCentralUserDTO.lastName = json.lastName;
    createCentralUserDTO.password = json.password;

    this.authenticationService.createCentralUser(createCentralUserDTO, false, this.joinToken, this.prefix).subscribe(_result => {
      this.userCreated = true;
      this.submitting = false;
      let me = this;

      setTimeout(function() {
        me.router.navigate(['/central-login/login'], { queryParams: { platform: me.prefix }});
      }, 5000);

    }, _error => {
        this.userCreationFailure = true;
    });
  }

  checkPasswordStrength(event: any) {
    this.checkPassword = CommonUtil.checkPassWordStrength(event.target.value);
  }

  togglePassword(event: any) {
    const password = document.querySelector('#password');
    const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
    password.setAttribute('type', type);
    event.target.classList.toggle('fa-eye-slash');

  }
}